import { render } from "./BaseActionHeader.vue?vue&type=template&id=3662ec60&scoped=true"
import script from "./BaseActionHeader.vue?vue&type=script&lang=js"
export * from "./BaseActionHeader.vue?vue&type=script&lang=js"

import "./BaseActionHeader.vue?vue&type=style&index=0&id=3662ec60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3662ec60"]])

export default __exports__